module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.offergroup', {
            url: '/offergroup/{Id}?{pageNumber:int}&{sortBy}',
            reloadOnSearch: false,
            data: {
                pageMetadata: {
                    title: 'Shop Offer Group',
                    metaDescription: 'Shop Offer Group',
                    metaRobot: 'noindex',
                },
            },
            views: {
                'left-panel@shop': {
                    template: '<wow-product-group group-type="\'OfferGroup\'"></wow-product-group>',
                    controller: [
                        '$state', '$stateParams', 'OfferGroupService',
                        function ($state, $stateParams, offerGroupService) {
                            return offerGroupService.selectOfferGroup($stateParams.Id).then((group) => {
                                if (!group) {
                                    $state.go('error.404', null, { location: 'replace' });
                                }
                                if (!isNaN($stateParams.Id)) {
                                    $state.go('shop.offergroup', {
                                        Id: group.Url,
                                        name: $stateParams.name,
                                    }, { location: 'replace' });
                                }
                                return group;
                            });
                        },
                    ],
                },
                'center-panel@shop': {
                    controller: [
                        '$state', 'OfferGroupService', function ($state, offerGroupService) {
                            this.$state = $state;
                            this.offerGroupService = offerGroupService;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-offer-group-tile-list
                            ng-if="::$ctrl.offerGroupService.selectedGroup"
                            offer-group-id="$ctrl.$state.params.Id"
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy">
                        </wow-offer-group-tile-list>
                    `,
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/offergroups.js